import React from 'react';
import TitleField from '../ObjectFieldTemplate/TitleField';

function ArrayFieldTitle({ expandable, toggleExpand, sectionType = 'section', expanded, fieldPathId, title, required, bindings = {} }) {
  if (!title) {
    return null;
  }

  return (
    <TitleField
      id={fieldPathId.$id}
      title={title}
      sectionType={sectionType}
      expandable={expandable}
      expanded={expanded}
      required={required}
      toggleExpand={toggleExpand}
      bindings={bindings}
    />
  );
}

export default ArrayFieldTitle;
